import { Pipe, PipeTransform } from '@angular/core'
import * as datefns from 'date-fns'

@Pipe({
   name: 'vspTime',
   standalone: false,
})
export class VspTimePipe implements PipeTransform {
   transform(value: string | number | Date, ...args: unknown[]): string {
      let date = datefns.parse('2000-01-01T' + value, "yyyy-MM-dd'T'HH:mm:ss", new Date())
      if (date.getMinutes() === 0) return datefns.format(date, 'haaaaa')
      else return datefns.format(date, 'h:mmaaaaa')
   }
}
